import { Easing, Tween } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import AnimationClip from '../AnimationClip';
import ElementComponent from '../../../Component/UI/Element';
import Renderable from '../../../Component/Renderable';
import { delay } from '../../../Utility/Task/TaskQueue';

export class SuitcaseOpen extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const BOTTOM: string = 'bottom_container';
        const BOOSTERS: string = `${BOTTOM}/suitcase_boosters`;
        const SUITCASE_OPEN: string = `${BOTTOM}/suitcase_open_button`;
        const SUITCASE_CLOSE: string = `${BOTTOM}/suitcase_close_button`;
        const TICKETS: string = `${BOOSTERS}/tickets_mask/tickets_container`;
        const BTN_INFO: string = `${BOOSTERS}/button_info`;

        const suitcaseClose: GameObject = gameObject.find(SUITCASE_CLOSE);
        const suitcaseOpen: GameObject = gameObject.find(SUITCASE_OPEN);
        const tickets: GameObject = gameObject.find(TICKETS);
        const btnInfo: GameObject = gameObject.find(BTN_INFO);

        const suitcaseElement: ElementComponent = suitcaseOpen.getComponent(
            ElementComponent
        );
        const ticketsElement: ElementComponent = tickets.getComponent(
            ElementComponent
        );
        const infoRenderable: Renderable = btnInfo.getComponent(Renderable);

        // Swap suitcases (close -> open).
        suitcaseClose.getComponent(Renderable).visible = false;
        suitcaseOpen.getComponent(Renderable).visible = true;

        yield* delay(300);

        const suitcaseTween: Tween = this.getTween(suitcaseElement);
        suitcaseTween.to({ rotation: -10 / 180 * Math.PI }, 80);

        yield* this.startTween(suitcaseTween);

        suitcaseTween.to({ rotation: 10 / 180 * Math.PI }, 160);

        yield* this.startTween(suitcaseTween);

        suitcaseTween.to({ rotation: 0 }, 80);

        yield* this.startTween(suitcaseTween);

        const moveUpTween: Tween = this.getTween(ticketsElement.pivot);
        ticketsElement.pivot.y = 0;
        moveUpTween.to({ y: 1 }, 500).easing(Easing.Quadratic.Out);

        yield* this.startTween(moveUpTween);

        const fadeInTween: Tween = this.getTween(infoRenderable);
        fadeInTween.to({ alpha: 1 }, 250);

        yield* this.startTween(fadeInTween);
    }
}
